/* global window */
import cookieDough from 'cookie-dough';

const cookie = cookieDough();
const hj = window.hj;

function triggerNotSignedUp() {
  if (!hj) {
    return;
  }

  if (!cookie.get('ajs_user_id') || cookie.get('ajs_user_id') === 'null') {
    triggerNotSignedUpPerPage(window.location.pathname);
  }
}

function triggerNotSignedUpPerPage(pathname) {
  const regex = /^\/authenticate\/.+\/.+\/?$/;

  if (pathname === '/') {
    return trigger('not_signed_up_homepage');
  }

  if (pathname === '/pricing') {
    return trigger('not_signed_up_pricing');
  }

  if (regex.test(pathname)) {
    return trigger('not_signed_up_auth_catalog');
  }

  return null;
}

function trigger(name) {
  console.warn(`Triggering ${name}`); // eslint-disable-line no-console
  hj('trigger', name);
}

export default {
  triggerNotSignedUp
};



// WEBPACK FOOTER //
// ./src/modules/triggers/index.js